module.exports = __webpack_public_path__ + "img/1544198486.c873dc57.jpg";